import { render, staticRenderFns } from "./AfterSaleDetail.vue?vue&type=template&id=4614adb7&scoped=true"
import script from "./AfterSaleDetail.vue?vue&type=script&lang=js"
export * from "./AfterSaleDetail.vue?vue&type=script&lang=js"
import style0 from "./AfterSaleDetail.vue?vue&type=style&index=0&id=4614adb7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4614adb7",
  null
  
)

export default component.exports